<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          细分市场<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="marketSegmentName">
            <el-select ref="marketSegment" v-model="form.marketSegmentName" placeholder="细分市场" filterable clearable style="width:100%;" @change="changemarketSegment">
              <el-option
                v-for="item in MarketSegment"
                :key="item.marketSegmentID"
                :label="item.marketSegmentName"
                :value="item.marketSegmentID"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          应用场合<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="applicationScenariosName">
            <el-select ref="applicationScenarios" v-model="form.applicationScenariosName" placeholder="应用场合" filterable style="width:100%;" @change="changeApplication">
              <el-option
                v-for="(item,index) in Application"
                :key="index"
                :label="item.applicationName"
                :value="item.applicationID"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          应用场景<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="applicationSceneName">
            <el-select ref="applicationScene" v-model="form.applicationSceneName" placeholder="应用场景" filterable style="width:100%;" @change="changeApplicationScene">
              <el-option
                v-for="(item,index) in ApplicationScenarios"
                :key="index"
                :label="item.applicationScenariosName"
                :value="item.applicationScenariosID"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getMarketSegment, getOccasion, getScenarios } from '@/API';
export default {
  data () {
    return {
      MarketSegment: [],
      Application: [],
      ApplicationScenarios: []
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    initMarketSegment () {
      getMarketSegment(this.form.contractType).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.MarketSegment = json.data;
        }
      }).catch(() => {
      });
    },
    changemarketSegment (val) {
      if (val) {
        this.$nextTick(() => {
          this.form.marketSegmentName = this.$refs.marketSegment.selected.currentLabel;
          this.form.marketSegmentCode = val;
        });
        this.Application = [];
        this.ApplicationScenarios = [];
        this.form.applicationScenariosCode = '';
        this.form.applicationSceneCode = '';
        this.form.applicationScenariosName = '';
        this.form.applicationSceneName = '';
        this.initApplication(val, this.form.contractType);
      }
    },
    initApplication (val, type) {
      getOccasion(val, type).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.Application = json.data;
        }
      }).catch(() => {
      });
    },
    changeApplication (val) {
      // this.$nextTick(() => {
      //   this.form.applicationScenariosName = this.$refs.applicationScenarios.selected.currentLabel;
      //   this.form.applicationScenariosCode = val;
      // });
      this.$forceUpdate();
      this.form.applicationScenariosCode = val;
      this.form.applicationScenariosName = this.Application.find(row => row.applicationID === val).applicationName;

      this.form.applicationSceneCode = '';
      this.form.applicationSceneName = '';

      this.ApplicationScenarios = [];
      this.initScenarios(val, this.form.contractType);
    },
    initScenarios (val, type) {
      getScenarios(val, type).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ApplicationScenarios = json.data;
        }
      }).catch(() => {
      });
    },

    changeApplicationScene (val) {
      // this.$nextTick(() => {
      //   this.form.applicationSceneName = this.$refs.applicationScene.selected.currentLabel;
      //   this.form.applicationSceneCode = val;
      // });
      this.$forceUpdate();
      this.form.applicationSceneCode = val;
      this.form.applicationSceneName = this.ApplicationScenarios.find(row => row.applicationScenariosID === val).applicationScenariosName;
    },

    initData () {
      if (this.form.marketSegmentCode) {
        this.initApplication(this.form.marketSegmentCode, this.form.contractType);
      }
      if (this.form.applicationScenariosCode) {
        this.initScenarios(this.form.applicationScenariosCode, this.form.contractType);
      }
    }
  },

  mounted () {
    this.initMarketSegment();
    this.initData();
  }
  // watch:{
  //   form(val){

  //   }
  // }
};
</script>
